import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import mn from './mn.json';
import en from './en.json';

const resources = {
  mn,
  en,
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'mn',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
